
//@flow
import React, {useEffect, useState} from 'react';
import {getRouteUrl} from "../../helpers/routing/getRouteUrl";
import {ROUTE_CART} from "../../routers/routes";
import PaymentStatusPage from "./paymentStatusPage";
import useUserData from "../../hooks/user/useUserData";
import useQueryParams from "../../hooks/useQueryParams";
import {useTranslation} from "react-i18next";
import {PRODUCT_INFO} from "../../locales/components/namespaces";
import axios from "axios";
import {API} from "../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../helpers/errorHandling";
import ContentLoader from "../../components/mui/general/contentLoader/contentLoader";

const OnlinePaymentsCancel = () => {
    const [loading, setLoading] = useState(true);
    const [response, setResponse] = useState(null);

    const {token} = useUserData();
    const queryParams = useQueryParams();
    const {t} = useTranslation(PRODUCT_INFO);
    useEffect(() => {

        const params = {};

        for (const [key, value] of queryParams.entries()) {
            if (key !== 'Parameters') {
                params[key] = value;
            }
        }

        params['Parameters'] = queryParams.getAll('Parameters');

        axios({
            method: 'post',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            url: `${API}/en/brew/payments/failure`,
            params: params,
        })
            .then((res) => {
                setResponse(res.data);
            })
            .catch((error) => {

                enqueueSnackbar(
                    handleAxiosErrors(
                        error,
                        t("An error occurred during payment verification")
                    ),
                    {
                        variant: "error",
                        autoHideDuration: 4000,
                    }
                );

                //history.push(getRouteUrl(ROUTE_CART));
            })
            .finally(() => {
                setLoading(false);
            });

    }, []);

    if (loading) {
        return (
            <div className={'bg-container'}>
                <ContentLoader loading={loading} show={true}/>
            </div>
        );
    }


    return (
        <PaymentStatusPage
            type="cancel"
            message="Your payment was cancelled."
            redirectTo={getRouteUrl(ROUTE_CART)}
        />
    );
};

export default OnlinePaymentsCancel;
